import { Engagement, EngagementState } from "@oysterhr/schema"

const EngagementStateByPriority = [
  EngagementState.Engaged,
  EngagementState.AssistedSetup,
  EngagementState.InProgress,
  EngagementState.WaitingForSignature,
  EngagementState.Draft,
  EngagementState.Terminated,
]

function engagementStatePriority(state: EngagementState) {
  const index = EngagementStateByPriority.indexOf(state)

  // BUG FIX: Not all engagement states are listed above. If in engagement is in a different state
  // (such as `ON_HOLD`), the index variable above will be set to -1, causing these states to get
  // stored first. This ensures these states have the lowest possible priority.
  return index === -1 ? Object.keys(EngagementState).length : index
}

// This logic is part of the old useEngagement hook and is still being used in 2 customer/staff components
// We have decided to keep it for now, as changing those components is beyond the scope of the multiple engagements project
export const pickEngagementByPriority = (engagements: Array<Engagement>) => {
  const prioritizedEngagementStates = [...engagements].sort((a, b) => {
    const firstItemPriority = engagementStatePriority(a.state)
    const secondItemPriority = engagementStatePriority(b.state)

    const orderingResult = firstItemPriority - secondItemPriority

    /* If both have the same state, we take the most recent one */
    if (orderingResult === 0) {
      return a.createdAt < b.createdAt ? 1 : -1
    }

    return orderingResult
  })

  return prioritizedEngagementStates[0]
}
